import { IBooking } from '../../models/IBooking';
import { fromLocalDateTime } from '../../../../../shared/i18n/date-time/LocalDateTime';
import { timeZone } from '../../../../../../config/common';

export function sortBookingsByDate(a: IBooking, b: IBooking) {
	const dateA = fromLocalDateTime({
		date: a.parkingProductsQuote.startDate,
		time: parseTime(a.parkingProductsQuote.startTime),
		zone: timeZone,
	}).getTime();
	const dateB = fromLocalDateTime({
		date: b.parkingProductsQuote.startDate,
		time: parseTime(b.parkingProductsQuote.startTime),
		zone: timeZone,
	}).getTime();

	return dateA - dateB;
}

function parseTime(time: string) {
	const [hours, minutes] = time.split(':').map(Number);

	return { hours, minutes };
}
